import type { INavigationRoute } from '../../components/sidebar/NavigationRoutes'

/** Catalog ▸ Products (`/home/setup/items`); tabs cover item / types / categories. */
export const catalogProductsNavItem: INavigationRoute = {
  name: 'items',
  displayName: 'menu.products',
  gate: 'item',
  meta: {
    icon: 'inventory_2',
  },
}

/** Catalog ▸ Units of measure (`/home/setup/units`). */
export const catalogUnitsNavItem: INavigationRoute = {
  name: 'units',
  displayName: 'menu.unitsOfMeasure',
  gate: 'unit',
  meta: {
    icon: 'straighten',
  },
}

/** Inventory submenu: dashboard, locations, then items. */
export const inventorySidebarChildren: INavigationRoute[] = [
  {
    name: 'inventory-dashboard',
    displayName: 'menu.inventoryDashboard',
    gate: 'item',
    meta: {
      icon: 'dashboard',
    },
  },
  {
    name: 'inventory-locations',
    displayName: 'menu.inventoryLocations',
    gate: 'inventory-location',
    meta: {
      icon: 'location_on',
    },
  },
  {
    name: 'inventory-items',
    displayName: 'menu.inventoryItems',
    gate: 'inventory-item',
    meta: {
      icon: 'inventory_2',
    },
  },
]
